import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import aboutUsData from "./aboutus-data";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";
import InformationCard from "../../components/InformationCard/InformationCard";
import JourneyTimeline from "../../components/JourneyTimeline/JourneyTimeline";

const AboutUs = () => {
  const [heroSection, setHeroSection] = useState({});
  const [companyStory, setCompanyStory] = useState({});
  const [missionVision, setMissionVision] = useState({});
  const [values, setValues] = useState([]);
  const [journey, setJourney] = useState([]);

  useEffect(() => {
    setHeroSection(aboutUsData.hero_section);
    setCompanyStory(aboutUsData.company_story);
    setMissionVision(aboutUsData.mission_vision);
    setValues(aboutUsData.values);
    setJourney(aboutUsData.journey);
  }, []);

  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#FF6B35] to-[#e85a2b] pt-28 md:pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {heroSection.title}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            {heroSection.description}
          </p>
          <div className="mt-8 flex justify-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">100% Natural • No Preservatives • Export Quality</span>
            </div>
          </div>
        </div>
      </section>

      <section className="company-story-section text-[#2c3e50]">
        <FeatureTextSection
          title={companyStory.title}
          description={companyStory.description}
          className="bg-gray-100 py-20"
        />
      </section>

      <section className="mission-vision-section">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <Row gutter={32}>
            <Col xs={24} md={12}>
              <div className="bg-white rounded-xl shadow-lg p-8 h-full">
                <h3 className="text-3xl font-bold text-heading mb-4">Our Mission</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {missionVision.mission}
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="bg-white rounded-xl shadow-lg p-8 h-full">
                <h3 className="text-3xl font-bold text-heading mb-4">Our Vision</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {missionVision.vision}
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="values-section bg-gray-100">
        <h2 className="text-4xl md:text-5xl font-extrabold py-8 text-[#2c3e50] text-center">Our Values</h2>
        <div className="max-w-screen-xl mx-auto px-6">
          <Row gutter={16} className="flex flex-wrap justify-center py-12">
            {values.map((value, idx) => (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={6}
                key={idx}
                className="gap-4 mb-3"
              >
                <InformationCard
                  feature={value}
                  customClassName="bg-white h-full w-full"
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="journey-section">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <FeatureTextSection
            title="Our Journey"
            description="From humble beginnings to becoming a trusted name in fruit pulp manufacturing"
          />
          <JourneyTimeline journey={journey} />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
